import { AspectRatio, Flex, GridItem, Image, Text } from '@chakra-ui/react';
import { PrizeTicketIcon } from '~/public/assets/icon/prize_ticket_icon';
import { PrizeTicket } from '~/types/resources/prizeTicket';

type Props = {
  availablePrizeTicket: PrizeTicket;
  ticketLength: number;
  onOpen: () => void;
  setSelectedTicketId: (newSelectedTicketId: string) => void;
};

export const PrizeTicketItem: React.FC<Props> = (props: Props) => {
  return (
    <GridItem
      onClick={() => {
        props.setSelectedTicketId(props.availablePrizeTicket.ticket_id);
        props.availablePrizeTicket.ticket_id && props.onOpen();
      }}
      as="label"
      p="8px"
      position="relative"
    >
      <AspectRatio ratio={1 / 1}>
        <Image
          src={props.availablePrizeTicket.thumbnail_url}
          alt={`${props.availablePrizeTicket.name}の画像`}
          loading="lazy"
          pointerEvents="none"
        />
      </AspectRatio>
      <Flex
        rounded="50px"
        w="24px"
        h="24px"
        px="4px"
        zIndex={2}
        right={1}
        bottom={1}
        bgColor="main"
        position="absolute"
        align="center"
        justify="center"
      >
        <Text fontSize="12px" lineHeight="20px" color="white">
          {props.ticketLength}
        </Text>
      </Flex>
      <Flex
        zIndex={2}
        bottom={0}
        left={0}
        position="absolute"
        align="center"
        justify="center"
      >
        <PrizeTicketIcon />
      </Flex>
    </GridItem>
  );
};
